import ProfilePhotoForm from './ProfilePhotoForm';

export default ProfilePhotoForm;
